import { render, staticRenderFns } from "./UltimateLearningOutcomeSubTree.vue?vue&type=template&id=0009617a&"
import script from "./UltimateLearningOutcomeSubTree.vue?vue&type=script&lang=js&"
export * from "./UltimateLearningOutcomeSubTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports